import { render, staticRenderFns } from "./decorate_manage.vue?vue&type=template&id=6cec8343&scoped=true&"
import script from "./decorate_manage.vue?vue&type=script&lang=js&"
export * from "./decorate_manage.vue?vue&type=script&lang=js&"
import style0 from "./decorate_manage.vue?vue&type=style&index=0&id=6cec8343&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec8343",
  null
  
)

export default component.exports